import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Colloegepicnic() {



    const cardData =
    {
        keyword: 'College Picnic Places at Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: College Picnic Places at Morachi Chincholi Pune',
        headingDescription: 'Looking for the perfect college picnic spot near Pune? Anand Krushi Paryatan Kendra is one of the best college picnic places at Morachi Chincholi Pune, just 55 km from the city. Spread across 40 acres, this dynamic agri-tourism farm offers an unforgettable blend of nature, adventure, and cultural immersion tailored for students and groups. A day here includes thrilling activities like bullock cart and tractor rides, horse riding, boating, swimming, and a lively rain-dance experience. Students can engage in traditional village games, enjoy puppet and magic shows, and build camaraderie through outdoor fun.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Tractor & Bullock Cart Safari",
    "description": "Start the day with an exciting tractor or bullock cart ride through farms, flower patches, and village lanes. Great for group photos, laughter-filled moments, and soaking in the rural atmosphere right from the start."
  },
  {
    "title": "Interactive Organic Farming Tour",
    "description": "Get hands-on with real farm work—try seed sowing, watering, composting, and using traditional tools. The experience offers insights into sustainable agriculture while promoting teamwork and appreciation for nature."
  },
  {
    "title": "Traditional Maharashtrian Breakfast",
    "description": "Enjoy a hearty breakfast of misal-pav, poha, or sabudana khichdi prepared on a chulha. Served under bamboo shelters or trees, it sets a perfect tone for a day filled with rustic charm."
  },
  {
    "title": "Fun Games & Team Activities",
    "description": "Engage in tug-of-war, sack races, lagori, kabaddi, kho-kho, and more. These traditional games spark friendly competition and strengthen group bonding—perfect for ice-breaking among students."
  },
  {
    "title": "Adventure Zone & Rope Activities",
    "description": "Try rope bridges, balancing beams, and bamboo trails that challenge coordination and build confidence. College students especially enjoy group obstacle relays and rope-based mini adventures."
  },
  {
    "title": "Rain Dance & Water Splash Zone",
    "description": "Turn up the energy with DJ-led rain dance and water fun. Colorful splash pools and music make this one of the most exciting parts of the picnic—ideal for large student crowds and summer events."
  },
  {
    "title": "Unlimited Rural Thali Lunch",
    "description": "Feast on zunka-bhakar, bharli vangi, pithla, dal-rice, pickles, and gulab jamun—served on banana leaves. The open-air setup and homemade flavors add to the wholesome, rural dining experience."
  },
  {
    "title": "Cultural Dance & Folk Music",
    "description": "Enjoy lavani, dholki, or lezim performances in the afternoon. Some farms allow students to participate—creating unforgettable memories and showcasing Maharashtra’s rich rural heritage."
  },
  {
    "title": "Peacock & Bird Watching Trails",
    "description": "Take peaceful strolls through nature trails, spotting peacocks, parrots, and kingfishers. It’s a quiet break from the energy-packed games, perfect for group photos or Instagram-worthy moments."
  },
  {
    "title": "Bonfire & Sunset Chill (Optional)",
    "description": "For evening outings or overnight picnics, enjoy a relaxed bonfire with folk songs, snacks, and storytelling under the stars. A great way to wind down and reflect on the day's fun."
  }
],




"services": [
  {
    "name": "Fun College Outings Near Pune",
    "description": "Anand Krushi Paryatan Kendra offers vibrant and youthful outdoor experiences for college groups looking to unwind. With lush surroundings, group activities, and rustic charm, it’s perfect for bonding, recreation, and unforgettable college memories just a short ride from Pune."
  },
  {
    "name": "Group Picnic Spots for College Students",
    "description": "Our wide-open picnic zones are perfect for large college groups. Enjoy group seating, rural-themed décor, team games, and flexible meal plans that make organizing a one-day outing both easy and exciting."
  },
  {
    "name": "Youth-Friendly Activities at Morachi Chincholi",
    "description": "From bullock cart races to mango plucking (seasonal), and group competitions to quirky photo spots, Anand Krushi Paryatan Kendra curates a mix of fun and local flavor that resonates with college students."
  },
  {
    "name": "College Trip with Adventure Games",
    "description": "Amp up the energy with adventure activities like rope climbing, net crossing, balance bridges, and fun obstacle courses. These are group-friendly, energizing, and safe for enthusiastic college participants."
  },
  {
    "name": "Open-Air Party Spaces for College Groups",
    "description": "Celebrate birthdays, achievements, or just life—with our open-air event spaces. Add music, lighting, and cultural décor to create a chilled-out rural rave, away from city limits and restrictions."
  },
  {
    "name": "Affordable College Picnic Venues",
    "description": "Our pocket-friendly group packages include food, adventure activities, music, and dedicated picnic zones—perfect for student budgets without compromising on the fun factor."
  },
  {
    "name": "Farm-Based Fun for College Students",
    "description": "Connect with nature and village life through interactive farm experiences—get involved in sowing, watering, or even learning about organic techniques. A refreshing contrast to city routines and college schedules."
  },
  {
    "name": "Photography Spots for Students",
    "description": "Our scenic backdrops, nature trails, farm structures, and peacock sightings make for perfect Insta-worthy moments. Ideal for pre-farewell photoshoots or college magazine content."
  },
  {
    "name": "Outdoor Sports and Games",
    "description": "Enjoy group sports like cricket, volleyball, and tug-of-war in wide natural fields. We also organize rustic games like lagori and kho-kho on request—ideal for friendly rivalries and teamwork."
  },
  {
    "name": "Rain Dance and Music Setup",
    "description": "Add a splash of fun to your outing with our rain dance setup and music system. Perfect for summer college breaks or farewell events—it’s safe, energetic, and unforgettable."
  },
  {
    "name": "Camping Options for College Outings",
    "description": "Want to turn your one-day outing into a night under the stars? Our tented accommodations and bonfire setups offer a memorable camping experience with cultural add-ons and group meals."
  },
  {
    "name": "Cultural Immersion Trips for Students",
    "description": "Combine fun with learning by exploring rural crafts, traditional Maharashtrian cuisine, folk music, and local agricultural practices. Great for students in cultural studies, environmental sciences, or social outreach groups."
  },
  {
    "name": "Evening Bonfire & DJ Setup",
    "description": "As the sun sets, enjoy bonfires with DJ music or folk dance around the firepit. Add marshmallows, games, or cultural performances for an unforgettable evening vibe."
  },
  {
    "name": "Quick Getaways for College Groups",
    "description": "Just 1.5 hours from Pune, our location is perfect for spontaneous short trips or pre-planned semester breaks. Easy logistics, scenic routes, and flexible planning make it a go-to spot for colleges."
  },
  {
    "name": "Farm Food Experiences for Youth",
    "description": "Enjoy authentic farm-to-plate Maharashtrian meals, mango-based treats (seasonal), and snacks made on-site. You can even watch your food being cooked in traditional chulhas for an immersive rural taste experience."
  }
],
"tableData": [
  ["Fun College Outings Near Pune", "- Group Picnic Spots for College Students"],
  ["Youth-Friendly Activities at Morachi Chincholi", "- College Trip with Adventure Games"],
  ["Open-Air Party Spaces for College Groups", "- Affordable College Picnic Venues"],
  ["Farm-Based Fun for College Students", "- Photography Spots for Students"],
  ["Outdoor Sports and Games", "- Rain Dance and Music Setup"],
  ["Camping Options for College Outings", "- Cultural Immersion Trips for Students"],
  ["Evening Bonfire & DJ Setup", "- Quick Getaways for College Groups"],
  ["Farm Food Experiences for Youth", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Vibrant Natural Setting",
    "WhyChoosedescription": "Morachi Chincholi offers sprawling open spaces surrounded by lush greenery and thousands of free-roaming peacocks, providing a lively and refreshing atmosphere perfect for college group outings."
  },
  {
    "WhyChooseheading": "Adventure and Team Activities",
    "WhyChoosedescription": "The destination features exciting activities like zip-lining, rope climbing, tractor rides, and outdoor games that foster team bonding, making it an ideal spot for college picnics that combine fun and adventure."
  },
  {
    "WhyChooseheading": "Cultural Experiences",
    "WhyChoosedescription": "Students can enjoy traditional folk music, puppet shows, and local food, giving them a chance to connect with Maharashtra's rural culture while relaxing in a natural environment."
  },
  {
    "WhyChooseheading": "Affordable and Group-Friendly Packages",
    "WhyChoosedescription": "Morachi Chincholi offers budget-friendly packages tailored for college groups, including meals, activities, and transportation options, ensuring a seamless and cost-effective picnic experience."
  },
  {
    "WhyChooseheading": "Safe and Spacious Environment",
    "WhyChoosedescription": "The open layout and well-maintained facilities provide a safe space for large groups to celebrate, socialize, and engage in recreational activities without worry."
  },
  {
    "WhyChooseheading": "Convenient Accessibility",
    "WhyChoosedescription": "Located just about 50-60 km from Pune, Morachi Chincholi is easily reachable by bus or private transport, making it an excellent choice for a quick day trip for college students."
  }
]
























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi a good spot for college picnics?',
    answer: 'Yes! Morachi Chincholi offers a vibrant mix of outdoor activities, natural beauty, and peaceful rural ambiance perfect for college group outings.',
  },
  {
    id: 'FAQ2',
    question: 'What activities can college groups enjoy at Morachi Chincholi?',
    answer: 'Students can engage in bullock cart rides, rain dance, nature walks, traditional games, farm visits, and photography sessions with peacocks.',
  },
  {
    id: 'FAQ3',
    question: 'Are there facilities to accommodate large college groups?',
    answer: 'Yes, several resorts and agro-tourism centers provide spacious venues, seating, dining arrangements, and lodging for large groups.',
  },
  {
    id: 'FAQ4',
    question: 'Can college picnics include team-building activities?',
    answer: 'Absolutely. Customized team-building exercises and outdoor challenges can be organized to enhance group bonding and leadership skills.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals provided during college picnics?',
    answer: 'Yes, traditional Maharashtrian meals and snacks made from fresh farm ingredients are usually included in picnic packages.',
  },
  {
    id: 'FAQ6',
    question: 'Is Morachi Chincholi easily accessible from Pune for college students?',
    answer: 'Morachi Chincholi is about 60–65 km from Pune, reachable in 1.5 to 2 hours by road, making it convenient for day trips or overnight stays.',
  },
  {
    id: 'FAQ7',
    question: 'Can college groups book overnight stays at Morachi Chincholi?',
    answer: 'Yes, many agro-tourism resorts offer homestay and dormitory-style accommodations suitable for college groups.',
  },
  {
    id: 'FAQ8',
    question: 'What is the best time to plan a college picnic here?',
    answer: 'The ideal season is from October to March when the weather is pleasant and outdoor activities are enjoyable.',
  },
  {
    id: 'FAQ9',
    question: 'Are there entertainment options for college picnics?',
    answer: 'Yes, many venues offer DJ setups, rain dance, bonfires, and live folk music to keep college groups entertained.',
  },
  {
    id: 'FAQ10',
    question: 'How can I book a college picnic at Morachi Chincholi?',
    answer: 'Contact agro-tourism centers like Anand Krushi Paryatan Kendra directly to inquire about group packages, pricing, and availability.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Rahul Deshmukh, College Student, Pune',
    feedback: "Our college picnic to Morachi Chincholi was fantastic! The activities and natural setting made for a refreshing break from studies.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Sneha Kulkarni, Group Leader, PCMC',
    feedback: "Loved the peaceful environment and well-organized facilities. The team-building games and rain dance were big hits with our group.",
    rating: 5,
  },
];




























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "College Picnic Places at Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/college-picnic-morachi-chincholi.jpg",
  "description": "Enjoy fun college outings near Pune at Morachi Chincholi with group picnic spots, adventure games, open-air party spaces, rain dance, camping, bonfire, DJ setup, and farm food experiences for youth.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "730"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/college-picnic"
  }
};




    return (
        <div>
<Helmet>
  <title>College Picnic Places at Morachi Chincholi Pune | Adventure & Group Fun</title>
  <meta 
    name="description" 
    content="Plan college picnic outings near Pune at Morachi Chincholi with group picnic spots, youth-friendly adventure games, rain dance, camping, bonfire, DJ setup, and farm food experiences." 
  />
  <meta 
    name="keywords" 
    content="Fun college outings near Pune, Group picnic spots for college students, Youth-friendly activities at Morachi Chincholi, College trip with adventure games, Open-air party spaces for college groups, Affordable college picnic venues, Farm-based fun for college students, Photography spots for students, Outdoor sports and games, Rain dance and music setup, Camping options for college outings, Cultural immersion trips for students, Evening bonfire & DJ setup, Quick getaways for college groups, Farm food experiences for youth" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Colloegepicnic;